<span class="load-event-value" *ngIf="oldValue">
    {{ oldValue | fullDate }}
</span>
<span class="load-event-empty-value" *ngIf="!oldValue"
      [i18n]="[{target: 'innerHTML', key: 'local-loads.search.details.events.empty-value'}]"></span>

<span class="load-event-values-separator">
    <i class="fa fa-arrow-right"></i>
</span>

<span class="load-event-value" *ngIf="newValue">
    {{ newValue | fullDate }}
</span>
<span class="load-event-empty-value" *ngIf="!newValue"
      [i18n]="[{target: 'innerHTML', key: 'local-loads.search.details.events.empty-value'}]">
</span>
